import { IExperience } from '../interfaces/interfaces';

export const myJourney: IExperience[] = [
    {
        companyName: 'Pentera',
        companyNote: 'Automated security validation',
        role: 'AI Engineer',
        period: '2024 — Present',
        location: 'Israel',
        current: true,
        highlights: [
            'Build production multi-agent systems on LangGraph and Amazon Bedrock — specialist sub-agents, tools and routing prompts under a ReAct orchestrator with fan-out/fan-in.',
            'Run RAG at scale: ingestion from Gong, Jira, Confluence and code, incremental embedding updates, and hybrid vector + full-text search on S3 Vectors.',
            'Built and operate a multi-provider LiteLLM gateway (Bedrock, Anthropic, Fireworks) with routing, fallbacks, prompt caching, spend tracking and Langfuse tracing.',
            'Own the AWS infrastructure behind it in Terraform — ECS Fargate, EKS, Multi-AZ RDS, CloudFront and WAF.',
        ],
        details: [
            {
                title: 'Agents & orchestration',
                items: [
                    'Multi-agent systems: specialist sub-agents, tools and routing prompts for an orchestrator agent (ReAct, fan-out/fan-in) on LangGraph/LangChain + Amazon Bedrock, including UI-context awareness.',
                    'Event-driven agent runtime: SQS/SNS workers, idempotent sub-agent execution, durable checkpointing and SSE streaming.',
                    'Python/FastAPI LangGraph agents with Postgres memory, stream cancellation and context-window recovery.',
                ],
            },
            {
                title: 'RAG & knowledge',
                items: [
                    'Ingestion pipelines across Gong, Jira, Confluence and source code, with incremental embedding updates.',
                    'Hybrid search — vector plus full-text — on S3 Vectors, with AST-based code chunking.',
                    'Architected a scalable multi-region knowledge-service stack, centralised behind API Gateway with CloudFront caching and read replicas.',
                ],
            },
            {
                title: 'LLM platform',
                items: [
                    'Built and run a multi-provider LiteLLM gateway (Bedrock, Anthropic, Fireworks) for coding agents: routing, fallbacks, prompt caching, spend tracking, Langfuse tracing and an MCP gateway.',
                    'Built MCP servers exposing product APIs to AI clients, and designed an MCP client layer for agents.',
                ],
            },
            {
                title: 'Evals & quality',
                items: ['promptfoo datasets, LLM-as-judge scoring and guardrails.', 'Full-stack Playwright end-to-end coverage running in CI.'],
            },
            {
                title: 'Infrastructure & CI/CD',
                items: [
                    'AWS IaC in Terraform: ECS Fargate autoscaling, EKS (IRSA, EFS CSI, CronJobs), RDS Postgres (Multi-AZ, IAM auth, backups), ALB, WAF, CloudFront, Secrets Manager/SSM, and Bedrock inference profiles with cost tagging.',
                    'CI/CD with GitHub Actions and OIDC, versioned internal package publishing, Bitbucket Pipelines and Jenkins.',
                ],
            },
            {
                title: 'Enablement',
                items: ['Author Claude Code skills the team uses to build agents and RAG sources.'],
            },
        ],
        stack: ['Python', 'TypeScript', 'LangGraph', 'Bedrock', 'LiteLLM', 'FastAPI', 'Terraform', 'AWS', 'PostgreSQL'],
    },
    {
        companyName: 'Amdocs',
        companyNote: 'Software & services for communications',
        role: 'Front-End Developer',
        period: '2021 — 2024',
        location: 'Israel',
        current: false,
        highlights: [
            'Developed and maintained responsive web applications in TypeScript, React and SCSS.',
            'Partnered with design and backend engineers to integrate services behind clean, well-typed interfaces.',
            'Ran code reviews, traced production defects and shipped fixes under customer-facing commitments.',
            'Supported customers on-site, resolving live production issues directly with their teams.',
        ],
        stack: ['TypeScript', 'React', 'SCSS', 'REST APIs', 'Git'],
    },
    {
        companyName: 'Webtech Innovation',
        companyNote: 'Web & portal development',
        role: 'Full Stack Developer',
        period: '2021',
        location: 'Israel',
        current: false,
        highlights: [
            'Delivered systems end to end — Java and MySQL on the backend, HTML/CSS/JSP on the front.',
            'Built and customised Liferay Portal modules for client deployments.',
            'Worked in an agile team across the full feature lifecycle.',
        ],
        stack: ['Java', 'MySQL', 'Liferay', 'JavaScript'],
    },
];
